module.exports = __webpack_public_path__ + "img/2.8f79219a.png";